import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import type { ErgebnisInput } from '../../interfaces/ergebnis-input.model';
import { ResultsBaseService } from '../../services/results-base.service';

/** The "Über den Versicherer" box of the Tarifdetails page. */
@Component({
  selector: 'ui-versicherer-info',
  templateUrl: './versicherer-info.component.html',
  styleUrl: './versicherer-info.component.scss',
  imports: [AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersichererInfoComponent {
  private readonly results: ResultsBaseService<unknown, ErgebnisInput> = inject(ResultsBaseService);

  readonly bafinRegNr = input.required<string>();
  readonly versichererName = input.required<string>();

  protected readonly logo$ = computed(() => this.results.findVersichererLogo$(this.bafinRegNr()));
}
